import { FlowcodeType } from '@dtx-company/inter-app/src/types/flowcode'
import { GetTemplatesBrandKitFlowcodeDetailsQuery } from '@dtx-company/flow-codegen/src/code/generated.types'

export const formatBatchDataToFlowcodeType = (
  batchData: GetTemplatesBrandKitFlowcodeDetailsQuery['batch'] | undefined
): FlowcodeType | undefined => {
  if (!batchData) return
  return {
    ...batchData,
    studioConfig: {
      id: batchData?.studioConfig?.id ?? '',
      configuration: batchData.studioConfig?.configuration,
      isCustomizable: Boolean(batchData.studioConfig?.isCustomizable),
      source: batchData.studioConfig?.source ?? '',
      name: batchData.studioConfig?.name ?? ''
    },
    analytics: {
      lastScanDate: batchData.analytics?.lastScanDate ?? ''
    },
    activeLink: {
      id: batchData.activeLink?.id,
      redirectValue: batchData.activeLink?.redirectValue ?? '',
      shorturl: batchData.activeLink?.shorturl ?? '',
      redirectType: batchData.activeLink?.redirectType ?? ''
    },
    batchOwner: {
      isOwner: Boolean(batchData.batchOwner?.isOwner),
      user: {
        ithacaId: batchData.batchOwner?.user?.ithacaId,
        fullName: batchData.batchOwner?.user?.fullName ?? ''
      }
    }
  }
}
